import {TokenService} from "@/services/storage.service";
import  { AuthenticationError } from '@/services/responses/AuthenticationError';

export class State {

    authenticating: boolean = false

    accessToken: string|null = TokenService.getToken()

    authenticationError: AuthenticationError = new AuthenticationError('', 0);

}
